// extracted by mini-css-extract-plugin
export default {"mainInput":"ThreeDotMenu_mainInput__wfs1w","swiper":"ThreeDotMenu_swiper__OzE2L"};